function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u2705-Project",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wiadomo\\u015Bci",
  transform: "translate(-305.000000, -1078.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(273.000000, 1034.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Messages/Read",
  transform: "translate(30.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 21
}), /*#__PURE__*/React.createElement("g", {
  id: "wiadomosci_odebrane",
  transform: "translate(2.500000, 0.525000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  fill: "#EDEDED",
  points: "10.89 9.6915 13.95 9.6915 13.95 18.963 0.89 18.963 0.89 9.6915 3.78 9.6915"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.89,9.1665 C10.6138576,9.1665 10.39,9.40155051 10.39,9.6915 C10.39,9.98144949 10.6138576,10.2165 10.89,10.2165 L12.66,10.2165 L9.42,13.3665 L7.42,15.288 L5.42,13.3665 L2.17,10.2165 L3.78,10.2165 C4.05614237,10.2165 4.28,9.98144949 4.28,9.6915 C4.28,9.40155051 4.05614237,9.1665 3.78,9.1665 L0.91,9.1665 C0.62281193,9.1665 0.39,9.41095253 0.39,9.7125 L0.39,18.963 C0.39,19.2529495 0.613857625,19.488 0.89,19.488 L14,19.488 C14.2761424,19.488 14.5,19.2529495 14.5,18.963 L14.5,9.7125 C14.5,9.41095253 14.2671881,9.1665 13.98,9.1665 L10.89,9.1665 Z M1.39,10.8885 L1.39,10.8885 L4.62,13.986 L1.39,17.514 L1.39,10.8885 Z M1.92,18.438 L5.38,14.7 L7.08,16.338 C7.27359645,16.5198158 7.56640355,16.5198158 7.76,16.338 L9.46,14.7 L12.91,18.417 L1.92,18.438 Z M10.2,14.007 L13.43,10.9095 L13.43,10.9095 L13.43,17.535 L10.2,14.007 Z",
  id: "Shape",
  fill: "#555150",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.05,5.817 C10.6238697,5.45470908 9.99936755,5.5202818 9.65,5.964 L8.42,7.5285 L8.42,1.4175 C8.42,0.837601013 7.97228475,0.3675 7.42,0.3675 C6.86771525,0.3675 6.42,0.837601013 6.42,1.4175 L6.42,7.5285 L5.19,5.964 C4.82549207,5.51747778 4.18525926,5.46576667 3.76,5.8485 C3.33474074,6.23123333 3.28549207,6.90347778 3.65,7.35 L6.65,11.172 C6.8399799,11.4127338 7.12224634,11.5520539 7.42,11.5520539 C7.71775366,11.5520539 8.0000201,11.4127338 8.19,11.172 L11.19,7.35 C11.3751341,7.13174755 11.4652548,6.84234895 11.4386853,6.55141319 C11.4121158,6.26047743 11.2712608,5.99433461 11.05,5.817 Z",
  id: "Path",
  fill: "#C8C8C8"
}))))));

var SvgReadNews = function SvgReadNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "21px",
    viewBox: "0 0 15 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReadNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ReadNews.123b523f.svg";
export { ForwardRef as ReactComponent };